export const getGlobalUser = state => state.user;
